import { ApiService } from '../services/api/api.service';
import { DataService } from '../services/data/data.service';
var WalletComponent = /** @class */ (function () {
    function WalletComponent(_apiService, _dataService) {
        this._apiService = _apiService;
        this._dataService = _dataService;
    }
    WalletComponent.prototype.onGetTransactions = function (currency, addresses) {
        var apiModel = {};
        apiModel.currency = currency;
        apiModel.addresses = addresses;
        this._apiService.getRawTransactions(apiModel);
    };
    Object.defineProperty(WalletComponent.prototype, "tempResult", {
        get: function () {
            return this._dataService.rawTransactions;
        },
        enumerable: true,
        configurable: true
    });
    return WalletComponent;
}());
export { WalletComponent };
